import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { CategoriesIcon } from '@novafuturltd/shared'

interface MenuCategoriesProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuCategories = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuCategoriesProps) => {
  const { formatMessage } = useIntl()

  const isDefaultPath =
    pathname.startsWith('/casino/categories') &&
    !pathname.startsWith('/casino/categories-ordering')

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href={`/casino/categories`}
        selected={isDefaultPath}
      >
        <ListItemIcon>
          <CategoriesIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'casino.submenu.categories.title',
          })}
        />
      </MenuItem>
    </div>
  )
}
